let activeBody = false;

const setActiveBody = (value) => {
    activeBody = value;
}

export { activeBody, setActiveBody };